
export const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337';

export const FALLBACK_IMG = 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?w=400&h=240&fit=crop&crop=center';
